import React, { useMemo } from 'react';

import Box from '@mui/material/Box';

import { Layout } from 'src/styles';

import capaQuebradeira from '../assets/images/capa_quebradeira_2.png';
import capaEntreposto from '../assets/images/capa_entreposto_2.png';

import { useHasPermissionsMulti } from 'src/hooks/useHasPermissions';
import { ENTREPOSTO_VIEWS, GENERAL_ADMINS, GROUP_VIEWS } from 'src/constants/Permission';
import { Perfil } from 'src/constants/Perfil';

import HomeTotalsQuebradeira from 'src/components/HomeTotalsQuebradeira';
import HomeTotalsEntreposto from 'src/components/HomeTotalsEntreposto';
import HomeTotalsAdmin from 'src/components/HomeTotalsAdmin';

export default function Home() {
  const [isGroupView, isEntrepostoView, isAdmin] = useHasPermissionsMulti([
    GROUP_VIEWS,
    ENTREPOSTO_VIEWS,
    GENERAL_ADMINS,
  ]);
  const view: Perfil | undefined = useMemo(() => {
    if (isAdmin) {
      return Perfil.DIRECAO;
    }
    if (isGroupView) {
      return Perfil.QUEBRADEIRA;
    }
    if (isEntrepostoView) {
      return Perfil.ENTREPOSTO;
    }
    return;
  }, [isGroupView, isEntrepostoView, isAdmin]);

  const capa = isEntrepostoView ? capaEntreposto : capaQuebradeira;

  let HomeTotals = HomeTotalsQuebradeira;
  switch (view) {
    case Perfil.QUEBRADEIRA:
      HomeTotals = HomeTotalsQuebradeira;
      break;
    case Perfil.ENTREPOSTO:
      HomeTotals = HomeTotalsEntreposto;
      break;
    case Perfil.DIRECAO:
      HomeTotals = HomeTotalsAdmin;
      break;
  }

  return (
    <Box sx={Layout.homeTotals({ capa })}>
      <HomeTotals />
    </Box>
  );
}
